import React, { useEffect, useState } from 'react';
import { SideNavPanel } from './side-nav-panel/side-nav-panel';
import { SideNavDialog } from './side-nav-dialog/side-nav-dialog';
import { useAppActions, useAppState } from '../../overmind';
import { ISideNavRoute } from './side-nav.models';
import { generateCompanyRoutes, generateLearnerRoutes } from '../navigation.helpers';
import { Company } from '../../models';
import { PagePath } from '../navigation.enums';
import { FetchType } from '../../enums';
import { Panel } from '@keplerco/core';
import { ManageCompanyPanel } from '../../pages/companies/manage-company/manage-company.panel';

export function SideNav(props: { isMobile: boolean; isTablet: boolean; showSideNavDialog: boolean; onCloseSideNavDialog: () => void }): JSX.Element {
  const { isMobile, isTablet, showSideNavDialog, onCloseSideNavDialog } = props;

  const actions = useAppActions();
  const { user, forcedAssessments, assessmentYearCourses, assignedCourses, companyVariables, mode, permissions, freemiumAccount } = useAppState();

  const [learnerRoutes, setLearnerSideNavRoutes] = useState<ISideNavRoute[]>([]);
  const [companyRoutes, setCompanySideNavRoutes] = useState<ISideNavRoute[]>([]);
  const [showCompanySettingsFocusPanel, setShowCompanySettingsFocusPanel] = useState<boolean>(false);
  const [company, setCompany] = useState<Company>();

  useEffect(() => {
    if (!user) return;
    setLearnerSideNavRoutes(generateLearnerRoutes(user, forcedAssessments, assessmentYearCourses, assignedCourses));
    setCompanySideNavRoutes(generateCompanyRoutes(user, forcedAssessments, companyVariables.slug, mode, permissions, !!freemiumAccount));
  }, [user, forcedAssessments, assessmentYearCourses, assignedCourses, companyVariables.slug, mode, permissions]);

  useEffect(() => {
    if (!!showSideNavDialog) {
      setLearnerSideNavRoutes(currentRoutes => {
        const newRoutes = structuredClone(currentRoutes);
        newRoutes.forEach((route: ISideNavRoute) => (route.children = route.children?.filter(child => child.title !== 'Core Skills Map')));
        return newRoutes;
      });
    }
  }, [showSideNavDialog]);

  async function getCompany() {
    if (!companyVariables.slug) return setShowCompanySettingsFocusPanel(false);

    actions.startLoader({ path: PagePath.root, type: FetchType.DialogFetching });
    const data = await actions.getCompany(companyVariables.slug);
    setCompany(data);
    actions.stopLoader(PagePath.root);
  }

  function onOpenSettings() {
    if (!companyVariables.slug) return;
    setShowCompanySettingsFocusPanel(true);
    getCompany();
  }

  function onCloseSettings() {
    setShowCompanySettingsFocusPanel(false);
    setCompany(undefined);
  }
  return (
    <React.Fragment>
      {!isMobile && !isTablet ? (
        <SideNavPanel learnerRoutes={learnerRoutes} companyRoutes={companyRoutes} onOpenSettings={onOpenSettings} />
      ) : (
        <SideNavDialog learnerRoutes={learnerRoutes} companyRoutes={companyRoutes} open={showSideNavDialog} onClose={onCloseSideNavDialog} onOpenSettings={onOpenSettings} />
      )}

      <Panel open={showCompanySettingsFocusPanel} onClose={onCloseSettings}>
        {!!company && <ManageCompanyPanel company={company} onCancel={onCloseSettings} onSubmit={onCloseSettings} />}
      </Panel>
    </React.Fragment>
  );
}
